import { render, staticRenderFns } from "./changepwd.vue?vue&type=template&id=39015fb0&scoped=true&"
import script from "./changepwd.vue?vue&type=script&lang=js&"
export * from "./changepwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39015fb0",
  null
  
)

export default component.exports